////////////////////////////////////////////
//
// Base Methods
//
////////////////////////////////////////////

// Navbar Toggler
document.addEventListener('DOMContentLoaded', function () {
  const navbarToggle = document.querySelector('.navbar-toggle')
  const body = document.querySelector('body')

  function navToggle(event) {
    navbarToggle.classList.toggle('active')
    body.classList.toggle('navbar-mobile-active')

    if (navbarToggle.className == 'active') {
      navbarToggle.setAttribute('aria-expanded', false)
    } else {
      navbarToggle.setAttribute('aria-expanded', true)
    }
    event.preventDefault()
  }

  if (navbarToggle != null) {
    navbarToggle.addEventListener('click', navToggle)
  }
})
